import httpClient from "../../api/httpClient";
import Rotina from "../classes/Rotina";

interface HttpCalls {
    method: string;
    rota: string;
}

const calls: HttpCalls[] = [
    { method: "GET", rota: "Broadcast/Rotina/All" },
    { method: "GET", rota: "Broadcast/Rotina/All/Grupo/" }
];

const cacheKey: string = "RotinaCache";
const cacheKeySelC: string = "RotinaSelecionado";

const apiServico: string = "PORTAL"

class RotinaDataset extends httpClient {

    constructor() {
        super(String(apiServico));
    }

    async Listar(): Promise<Rotina[]> {
        return super.Get(calls[0].rota)
            .then((response) => {
                return JSON.parse(JSON.stringify(response.data));
            })
            .catch((erro) => {
                console.error(erro)
            });
    }

    async ListarPorGrupo(idGrupo: number): Promise<Rotina[]> {
        return super.Get(calls[1].rota +  idGrupo)
            .then((response) => {
                return JSON.parse(JSON.stringify(response.data));
            })
            .catch((erro) => {
                console.error(erro)
            });
    }

    getKeyCach(): string {
        return cacheKey;
    }

    getKeyCachClass(): string {
        return cacheKeySelC;
    }

    ListarFromCache(): Rotina[] {
        let result: Rotina[] = JSON.parse(cacheKey);
        return result;
    }

    AdicionarListaAoCache(value: Rotina[]) {
        localStorage.setItem(cacheKey, JSON.stringify(value));
    }

    LimparListaDoCache() {
        localStorage.removeItem(cacheKey);
    }

    AdicionarObjetoAoCache(value: Rotina) {
        localStorage.setItem(cacheKeySelC, JSON.stringify(value));
    }

    LimparObjetoDoCache() {
        localStorage.removeItem(cacheKeySelC);
    }

}
export default RotinaDataset;